export const PERMISSIONS: string = [
  // Access
  'access:ca',
  'access:hh',
  'access:mm',
  'access:wrt',
  'access:drt',
  'access:art',
  'access:irt',

  // UI
  'ui:irt:configuration',
].join(' ');
